import { ConstraintViolationList } from '@/static/enums/HydraType';

type RequestError = {
  response?: {
    status?: number;
    headers?: Record<string, string>;
    data?: Record<string, unknown>;
  };
};

/**
 * Whether the error handler of the request interceptor (./req.ts) has already
 * shown a notification for the given request error. Callers can use this to
 * avoid showing the same failure twice.
 *
 * NB: must be kept in sync with errorHandler in ./req.ts.
 */
export function isNotifiedByRequestInterceptor(error: unknown): boolean {
  if (typeof error === 'string') {
    // The handler rejects with the notified text when the message was JSON.
    return true;
  }

  const response = (error as RequestError | null)?.response;
  if (!response) {
    return false;
  }

  if (
    response.headers?.['content-type'] === 'application/ld+json; charset=utf-8'
  ) {
    return response.data?.['@type'] === ConstraintViolationList;
  }

  return response.status === 403 || response.data?.message !== undefined;
}
